import { z } from "zod";

export const contactFormSchema = z.object({
  name: z.string().trim().min(3, "Por favor, digite seu nome completo."),
  email: z.string().trim().email("Por favor, digite um e-mail valido."),
  phone: z
    .string()
    .trim()
    .regex(
      /^\(\d{2}\) \d{5}-\d{4}$/,
      "Por favor, digite um telefone valido no formato (99) 99999-9999.",
    ),
  message: z
    .string()
    .trim()
    .min(3, "Por favor, escreva uma mensagem para continuarmos."),
  origin: z.string().trim().optional(),
  utm_source: z.string().trim().optional(),
  utm_medium: z.string().trim().optional(),
  utm_campaign: z.string().trim().optional(),
  utm_content: z.string().trim().optional(),
  utm_term: z.string().trim().optional(),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;

export const contactOriginLabel = "Página de contato";

export const flowFoundationOriginLabel = "Landing FlowFoundation";

/** Rotula o lead pela página de serviço de origem, ex.: "Serviço UX/UI Design". */
export const servicePageOriginLabel = (service: string) => `Serviço ${service}`;

/** Idem para as páginas de solução, ex.: "Solução Modernização de Sistemas Legados". */
export const solutionPageOriginLabel = (solution: string) =>
  `Solução ${solution}`;
